import { useTranslate } from '@c3po/i18n'
import MessageCenterHeaderWidget from '@user-engagement/message-center-header-widget'

import React from 'react'

import LinkWrapper from 'components/LinkWrapper'

type Props = {
  memberId: number
  siteId: number
}

const MessageCenterWidget = ({ memberId, siteId }: Props) => {
  const { i18n } = useTranslate()

  return (
    <div data-testid="message-center-widget">
      <MessageCenterHeaderWidget
        pageName={''}
        siteId={siteId}
        memberId={memberId}
        linkWrapper={LinkWrapper}
        translations={{
          widgetTitle: i18n('postSales.messageCenter.homePage.icon'),
          emptyTitle: i18n('postSales.messageCenter.page.empty.title'),
          emptySubtitle: i18n('postSales.messageCenter.page.empty.body'),
          emptyButtonName: i18n('postSales.messageCenter.page.empty.cta'),
          errorTitle: i18n('postsales.messagecenter.page.error.title'),
          errorSubtitle: i18n('postsales.messagecenter.page.error.body'),
          errorRefreshButtonName: i18n('postsales.messagecenter.page.error.cta1'),
          errorReturnButtonName: i18n('postsales.messagecenter.page.error.cta2'),
        }}
      />
    </div>
  )
}

export default MessageCenterWidget
